import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CourseService } from '@app/_services/course.service';
import { MixpanelService } from '@app/_services/mixpanel.service';
import { AccountService } from '../_services/account.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: []
})
export class LoginComponent implements OnInit {
  public loginForm: FormGroup;
  public invalidLogin: boolean = false;
  public courseId = "5fa2046685f26526d5e9a76a";

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private auth: AccountService,
    private courseService: CourseService,
    private mixpanel: MixpanelService
  ) { 
  }

  ngOnInit() {
    this.initForm();

    this.auth.isAuthenticated().subscribe(isAuthenticated => {
      console.log("is authenticated", { authenticated: isAuthenticated})
      if (isAuthenticated) {
        this.router.navigate(["account"]);
      }
    });
  }

  initForm() {
    this.loginForm = this.fb.group({
      'email': ['', Validators.required],
      'password': ['', Validators.required]
    });
  }

  onSubmitLogin(value: any) {
    const email = value.email, password = value.password;
    this.auth.signIn(email, password)
      .subscribe(
        result => {

          this.mixpanel.identify(value.email);
          this.mixpanel.track("User logged in");

          // enroll user and then redirect to 
          this.courseService.enroll(this.courseId);

          this.router.navigate(['latin-america-spanish-course']);
          
        },
        error => {
          if (error.code === 'InvalidParameterException' ||
            error.code === 'NotAuthorizedException') {
            this.invalidLogin = true;
          }
          console.log(error);

        });
  }
}